<template>
  <div class="result-page">
    <div class="card">
      <div class="title">测评已提交</div>
      <div class="subtitle">结果由咨询师/管理员在管理端查看与解读。</div>

      <div class="section">
        <div class="section-title">提示</div>
        <div class="hint">
          为保护隐私与流程控制，测评完成后不支持通过公开链接查看结果。如需结果解释，请联系你的咨询师。
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicResult',
  props: ['uid'],
  data() {
    return {}
  },
}
</script>

<style scoped>
.result-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 28px 14px;
  background: var(--bg-body);
}
.card {
  width: min(920px, 100%);
  background: var(--bg-card);
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}
.title {
  font-size: 18px;
  font-weight: 900;
  color: var(--text-primary);
}
.subtitle {
  margin-top: 6px;
  color: var(--text-secondary);
  font-size: 13px;
}
.hint {
  color: var(--text-regular);
  line-height: 1.7;
  font-size: 14px;
}
.section {
  margin-top: 14px;
}
.section-title {
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 8px;
}
.kv {
  display: flex;
  gap: 10px;
  margin-bottom: 6px;
}
.k {
  width: 80px;
  color: var(--text-secondary);
}
.v {
  color: var(--text-primary);
  font-weight: 700;
}
.json {
  background: #0b1220;
  color: #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  overflow: auto;
  font-size: 12px;
}
.footer {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>
